const FilesAndLinks = () => import(/* webpackChunkName: "qraccess" */ "../../views/burdenFile/BurdenFile.vue")
const S3Uploads = () => import(/* webpackChunkName: "trips" */ "../../views/burdenFile/BurdenFileList.vue")

const burdenFile = [
    {
        path: "burdenFile",
        name: "Burden File",
        redirect: {
          name: "Burden List"
        },
        component: FilesAndLinks,
        children: [
          {
            path: "listBurdenFile",
            name: "Burden List",
            component: S3Uploads
          }
        ]
      }
];

export default burdenFile;
